import React from 'react';
import {LinkingOptions, NavigationContainer} from '@react-navigation/native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import SetDinamicPages from './pages/dinamicPages';
import HomePage from './pages/home';
import BillingHomePage from './pages/billingHomePage';
import { GlobalVariables } from './utils/globalVariables';

const Stack = createNativeStackNavigator();

//Pages class
export enum enumPages {
  dinamicPages = 'dinamicPages',
  inicio = 'inicio',
  facturacion = 'facturacion'
}
function PortalScreen() {
  const getTitle = (module:string):string =>{
    let page = module.charAt(0).toUpperCase() + module.slice(1);
    return `${page} - Laboratorio Médico Polanco`;
  };
  return (
    <Stack.Navigator>
      <Stack.Screen
      name={enumPages.dinamicPages}
      options={{
        headerShown: false,
        title: getTitle(enumPages.dinamicPages),
      }}
      component={SetDinamicPages}
      />
      <Stack.Screen
      name={enumPages.inicio}
      options={{
        headerShown: false,
        title: getTitle(enumPages.inicio),
      }}
      component={HomePage}
      />
      <Stack.Screen
      name={enumPages.facturacion}
      options={{
        headerShown: false,
        title: getTitle(enumPages.facturacion),
      }}
      component={BillingHomePage}
      />
    </Stack.Navigator>
  );
}
function App(): JSX.Element {
  const linking: LinkingOptions<any> = {
    prefixes: ['http://localhost:3000/Portal', 'http://localhost/Portal/'],
    config: {
      screens: {
        Portal: {
          path: 'Portal',
          screens: enumPages,
        },
      },
    },
  };
  return (
    <NavigationContainer linking={linking}>
      <Stack.Navigator screenOptions={{
        contentStyle:{
          backgroundColor: GlobalVariables.colors.secondary.white,
        },
      }}>
        <Stack.Screen
          name={'Portal'}
          options={{
            headerShown: false,
          }}
          component={PortalScreen}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
export default App;
